import { Injectable } from '@angular/core';
import { NetworkService } from '../../network/network.service';
import { NetworkResponse } from '../../network/NetworkResponse';
import { HttpMethod } from '../../network/HttpMethod';
import { BaseModel } from '../../../models/BaseModel';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(private networkService: NetworkService) { }

  decryptData(): Promise<NetworkResponse<BaseModel & { data: Record<string, string> }>> {
    return this.networkService.apiRequest({
      method: HttpMethod.GET,
      url: 'token/decrypt/data',
    });
  }
}
